import { BenchmarkTypeOf } from "@modules/benchmark/benchmarkTypes"
import { BoxTypeOf } from "@modules/box/boxTypes"
import { ProfileTypeOf } from "@modules/profile/profileTypes"
import { ProgramBundleTypeOf } from "@modules/programBundle/api/programBundleDto"
import { ProgramContentTypeOf } from "@modules/programs/programTypes"

export const ExploreContentTypes = [
  BenchmarkTypeOf,
  ProgramContentTypeOf,
  ProgramBundleTypeOf,
  BoxTypeOf,
  ProfileTypeOf,
] as const
export type ExploreContentType = (typeof ExploreContentTypes)[number]
export enum ExploreFilter {
  DEFAULT = "DEFAULT",
  BENCHMARK = "BENCHMARK",
  BOX = "BOX",
  PROGRAM = "PROGRAM",
  PROGRAM_BUNDLE = "PROGRAM_BUNDLE",
  PROFILE = "USER_PROFILE",
}

export const AvailableExploreContentTypes: ExploreContentType[] = [
  ProgramContentTypeOf,
  BenchmarkTypeOf,
  BoxTypeOf,
  ProfileTypeOf,
]
